<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Curso de las 50 horas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/",
        },
        {
          text: "Curso de las 50 horas",
          active: true,
        },
      ],
      text: `
         ... `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Curso de las 50 horas del sistema de gestión de seguridad y salud en el trabajo</h4>
              </div>

              <div class="col-6 text-right">
                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                  <b-list-group-item href="#list-item-1"
                    >¿Qué es el curso de las 50 horas? </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-2"
                    >¿Dónde puedo hacer el curso? </b-list-group-item
                  >
                    <b-list-group-item href="#list-item-3"
                    >Curso de las 20 horas</b-list-group-item
                  >
                <!--  <b-list-group-item href="#list-item-4"
                    > </b-list-group-item
                  >
                   <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <h4 id="list-item-1">¿Qué es el curso de las 50 horas?  </h4>
                  <p>Es una capacitación obligatoria, para desarrollar competencias en las personas que en su trabajo tengan relación con el Sistema de Gestión de la Seguridad y Salud en el trabajo SG-SST </p>
                 
                  <h4 id="list-item-2">¿Dónde puedo hacer el curso?</h4>
                  <p>En las siguientes opciones son las certificadas para realizar el curso:  
                 <br/><br/> -Si tu empresa está registrada ante ARLsura puedes registrarte en el siguiente link: <a href="https://www.arlsura.com/index.php/component/arl_regcgr/?view=registro">https://www.arlsura.com/index.php/component/arl_regcgr/?view=registro</a> 
                 <br/><br/> -Si su empresa no está registrada en ARL sura puede solicitar a la misma el registro para realizar el curso a través del siguiente  correo: <a href="educacionparacuidado@suramericana.com.co">educacionparacuidado@suramericana.com.co</a>  con sus datos personales y en un plazo de 8 días hábiles se estará notificando el inicio del curso junto con la ruta de ingreso y credenciales del trabajador. 
                 <br/><br/> -Puedes registrarte en la plataforma Sofia plus del Sena; <a href="http://oferta.senasofiaplus.edu.co/sofia-oferta/">http://oferta.senasofiaplus.edu.co/sofia-oferta/</a>
                 <br/><br/> -Si estas registrado ante la ARL Positiva ingresar a este link: 
                  <a href="https://posipedia.com.co/">https://posipedia.com.co/</a> <br/> Dar clic en la pestaña de EDUCATE, En el módulo de Curso Virtual 50 Horas en SG-SST; Dar clic en VER MAS, dar clic en INSCRIBIRSE; y diligenciar el formulario de inscripción. <br/> Tenga en cuenta lo siguiente: 
                 <br/><br/> 1. La inscripción deberá ser realizada por cada trabajador. 
                 <br/><br/> 2. En un plazo de 8 días hábiles se estará notificando el inicio del curso junto con la ruta de ingreso y credenciales del trabajador, al correo diligenciado con anterioridad en el formulario de inscripción de la plataforma. 
                  Si estas registrado en otra ARL o desear hacerlo con otra ARL, debes ponerte en contacto con ellos para que te faciliten la respectiva asesoría para la ruta del curso. <br/><br/>
                  La vigencia de este curso será de 3 años y a partir de estos, se deberá realizar una actualización de 20 horas.</p>
                 
                  <h4 id="list-item-3">Curso de las 20 horas</h4>
                  <p>El curso de 20 horas del SG-SST es una capacitación de refuerzo, obligatoria cada 3 años para los responsables del Sistema de Gestión de Seguridad y Salud en el Trabajo (SG-SST) en Colombia, la cual está reglamentada en la circular 0063 de 2020.<br/><br/>
                    <b> ¿Quiénes pueden ofrecer el curso de 20 horas del SG-SST?</b><br/><br/>
                  Las ARL, el SENA, cajas de compensación familiar, Instituciones de educación superior reconocidas por el Ministerio de Educación, empresas, gremios, asociaciones y entidades u organizaciones internacionales y la Policía Nacional.<br/><br/>

                  <b> ¿Cuáles son los requisitos para tomar el curso de 20 horas del SG-SST?</b><br/><br/>

                  Para tomar el curso de actualización de 20 horas del SG-SST se debe:<br/>
                  -	Tener el certificado del curso de 50 horas del SG-SST<br/>
                  -	Inscribirse en un oferente autorizado<br/>
                  </p>
                 <!--  <h4 id="list-item-4">ACTIVIDADES</h4>
                  <p>...</p>
                 <h4  id="list-item-5">Item 5</h4>
                  <p>{{ text }}</p>
                   <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> 
                  
                  <h4 hidden id="list-item-5"></h4>
                  <p>{{ text }}</p>
                   <h4 hidden id="list-item-6"></h4>
                  <p>{{ text }}</p>-->
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
